/*eslint-disable */
import React, { useState } from "react";
import {
  withFormik,
  Form as Formiker,
  Field as Fieldmik,
  FieldArray,
  getIn,
} from "formik";
import * as yup from "yup";
import {
  Form as FormUi,
  Container,
  Button,
  Icon,
  Dropdown,
  Segment,
  Header,
  Table,
  Label,
  Divider,
} from "semantic-ui-react";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import SearchDropdown from "../createShipmentComponent/searchDropdown";
import ErrorMessage from "../createShipmentComponent/ErrorMessages";
import * as _ from "lodash";
import { translate } from "react-i18next";
import { AllRegex } from "../../utils/validation";
import AddCheckpointModal from "./addCheckpointModal";
import RouteCheckpoints from "./routeCheckpoints";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import cogoToast from 'cogo-toast'
import { REQUIRED_FIELDS } from "../../utils/validationConstant";

const InsertRoute = ({
  values,
  touched,
  errors,
  setFieldValue,
  handleSubmit,
  editData,
  t,
}) => {
  const [rawsequence, setsequence] = useState(0);
  const setRouteList = (name, value) => {
    let stdObj = {
      checkPointType: "city",
      checkPointId: null,
      eta: "00:00:00",
      etd: "00:00:00",
      r_eta: "00:00:00",
      r_etd: "00:00:00",
      sequence: rawsequence + 1,
    };
    setsequence(stdObj.sequence);
    stdObj.checkPointId = value.raw?.checkPointMasterId;
    stdObj.checkPointType = value.raw?.checkPointType;
    setFieldValue(name, JSON.stringify(stdObj));
  };

  let addCheckpoint = (array) => {
    array.push({
      checkPointType: "",
      checkPointId: "",
      eta: "00:00:00",
      etd: "00:00:00",
      r_eta: "00:00:00",
      r_etd: "00:00:00",
      sequence: 1,
    })
  }

  return (
    <React.Fragment>
      <Formiker>
        <Container fluid className="mt-2">
          <Segment>
            <div className="ui form tiny">
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.route_code.title") || "Route Code"}{" "}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.routeCode && errors.routeCode ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="routeCode"
                    placeholder={
                      t("create.route_code.placeholder") || "Enter Route Code"
                    }
                  />
                  {touched.routeCode && errors.routeCode ? (
                    <div className="error-msg">
                      {t(`create.route_code.error_msg.${errors.routeCode}`) ||
                        errors.routeCode}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.route_name.title") || "Route Name"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  className="display-grid-center-imp"
                  width={4}
                  error={touched.routeName && errors.routeName ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="routeName"
                    placeholder={
                      t("create.route_name.placeholder") || "Enter Route Name"
                    }
                  />
                  {touched.routeName && errors.routeName ? (
                    <div className="error-msg">
                      {t(`create.route_name.error_msg.${errors.routeName}`) ||
                        errors.routeName}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.budgeted_time.title") || "Route TAT (in HRS)"}{" "}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.budgetedRouteTat && errors.budgetedRouteTat
                      ? true
                      : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="budgetedRouteTat"
                    placeholder={
                      t("create.budgeted_time.placeholder") ||
                      "Enter Route TAT (In HRS) "
                    }
                  />
                  {touched.budgetedRouteTat && errors.budgetedRouteTat ? (
                    <div className="error-msg">
                      {t(
                        `create.budgeted_time.error_msg.${errors.budgetedRouteTat}`
                      ) || errors.budgetedRouteTat}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.budgeted_distance.title") ||
                      "Budgeted Route KM (In KM)"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.budgetedRouteKm && errors.budgetedRouteKm
                      ? true
                      : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="budgetedRouteKm"
                    placeholder={
                      t("create.budgeted_distance.placeholder") ||
                      "Enter Route KM (In KMS)"
                    }
                  />
                  {touched.budgetedRouteKm && errors.budgetedRouteKm ? (
                    <div className="error-msg">
                      {t(
                        `create.budgeted_distance.error_msg.${errors.budgetedRouteKm}`
                      ) || errors.budgetedRouteKm}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.route_description.title") || "Route Description"}{" "}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.routeDescription && errors.routeDescription
                      ? true
                      : false
                  }
                >
                  <Fieldmik
                    component={"textarea"}
                    rows="3"
                    type="text"
                    style={{ width: "100%" }}
                    name="routeDescription"
                    placeholder={
                      t("create.route_description.placeholder") ||
                      "Enter Description"
                    }
                  />
                  {touched.routeDescription && errors.routeDescription ? (
                    <div className="error-msg">
                      {t(
                        `create.route_description.error_msg.${errors.routeDescription}`
                      ) || errors.routeDescription}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              {_.isEmpty(editData) && (
                <>
                  <Segment piled>
                    <center>
                      <Header size="small">
                        <b>{t("create.route_list.title") || "Route List"}</b>
                      </Header>
                    </center>
                    <Divider></Divider>
                    <Container className="small">
                      <FieldArray
                        name="checkPointLists"
                        render={(arrayHelpers) => (
                          <>
                            {values.checkPointLists &&
                              values.checkPointLists.length > 0
                              ? values.checkPointLists.map((items, index) => (
                                <div key={index}>
                                  <label
                                    className="labelName"
                                  >
                                    {t(
                                      "create.route_list.checkpoint.title"
                                    ) || "Check point"}
                                  </label>
                                  <FormUi.Group inline>
                                    <FormUi.Field
                                      style={{ display: "flex" }}
                                      error={
                                        getIn(
                                          errors,
                                          `checkPointLists[${index}].checkPointId`
                                        ) &&
                                          getIn(
                                            touched,
                                            `checkPointLists[${index}].checkPointId`
                                          )
                                          ? true
                                          : false
                                      }
                                    >
                                      <SearchDropdown
                                        setField={setRouteList}
                                        masterRoute="getRouteCheckPoints"
                                        masterRouteKey="checkPointMasterId"
                                        masterRouteName="checkPointName"
                                        fieldName={`checkPointLists[${index}].checkPointId`}
                                      />
                                      <ErrorMessage
                                        name={`checkPointLists[${index}].checkPointId`}
                                      />
                                      <Button
                                        className="ui mini"
                                        hidden={index === 0}
                                        style={{ marginLeft: "10px" }}
                                        onClick={() =>
                                          arrayHelpers.remove(index)
                                        }
                                        basic
                                        icon
                                        color="red"
                                      >
                                        <Icon name="trash" />{" "}
                                      </Button>
                                    </FormUi.Field>
                                  </FormUi.Group>
                                </div>
                              ))
                              : ""}
                            <Button
                              onClick={() => addCheckpoint(arrayHelpers)
                                // arrayHelpers.push({
                                //   checkPointType: "",
                                //   checkPointId: "",
                                //   eta: "00:00:00",
                                //   etd: "00:00:00",
                                //   r_eta: "00:00:00",
                                //   r_etd: "00:00:00",
                                //   sequence: rawsequence + 1,
                                // })
                              }
                              basic
                              color="blue"
                              size="mini"
                              icon
                              type="button"
                            >
                              <Icon name="plus" />
                              {t(
                                "create.route_list.checkpoint.action.add_more"
                              ) || "Add More"}
                            </Button>
                          </>
                        )}
                      />
                    </Container>
                  </Segment>
                </>
              )}
            </div>
          </Segment>
          {editData.routeMasterId && (
            <RouteCheckpoints route_id={editData.routeMasterId} />
          )}
        </Container>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {t("create.action_button.submit") || "Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  );
};

const FormikRoute = withFormik({
  validationSchema: yup.object({
    routeName: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    routeCode: yup.string().optional(),
    routeDescription: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    budgetedRouteTat: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    budgetedRouteKm: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    checkPointLists: yup.array().of(
      yup.object().shape({
        checkPointId: yup.string().optional(REQUIRED_FIELDS.REQUIRED),
      })
    ),
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
      routeName: props.editData.routeNamet || "",
      routeCode: props.editData.routeCode || "",
      budgetedRouteTat: props.editData.budgetedRouteTat || "",
      budgetedRouteKm: props.editData.budgetedRouteKm || "",
      routeDescription: props.editData.routeDescription || "",
      checkPointLists: [
        {
          checkPointType: "",
          checkPointId: "",
          eta: "00:00:00",
          etd: "00:00:00",
          r_eta: "00:00:00",
          r_etd: "00:00:00",
          sequence: +1,
        },
      ],
    };
  },
  async handleSubmit(values, { props }) {
    if (props.editData.routeMasterId) {
      await UpdateAxios({
        url: "routeMaster",
        payload: { ...values },
        uniqueId: props.editData.routeMasterId,
      })
        .then((res) => {
          if (res.data.status === 200) {
            cogoToast.success(typeof res.data.message === 'object' ? res.data.message.message : res.data.message, { position: "top-right" });
          } else {
            cogoToast.error(typeof res.data.message === 'object' ? res.data.message.message : res.data.message, { position: "top-right" });
          }
          props.onFormSubmit();
        })
        .catch((err) => {
          cogoToast.error(err.data.message, { position: "top-right" });
        });
    } else {
      let routeDetails = [];

      values.checkPointLists.forEach((item, index) => {
        let checkPoint = JSON.parse(item.checkPointId)
        checkPoint.sequence = index + 1;
        routeDetails.push(checkPoint);
      });
      let submitData = {
        routeName: values.routeName,
        routeCode: values.routeCode,
        budgetedRouteKm: values.budgetedRouteKm,
        budgetedRouteTat: values.budgetedRouteTat,
        routeDescription: values.routeDescription,
        routeList: JSON.stringify(routeDetails),
      };
      await CreatAxios({
        url: "routeMaster",
        payload: { ...submitData },
      })
        .then((res) => {
          if (res.data.status === 200) {
            cogoToast.success(typeof res.data.message === 'object' ? res.data.message.message : res.data.message, { position: "top-right" });
          } else {
            cogoToast.error(typeof res.data.message === 'object' ? res.data.message.message : res.data.message, { position: "top-right" });;
          }
          props.onFormSubmit();
        })
        .catch((err) => {
          cogoToast.error(err.data.message, { position: "top-right" });
        });
    }
  },
})(InsertRoute);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("route")(FormikRoute)
);
